<template>
    <page-content>
        <h4 class="page-title-padding" slot="header">基础人员信息维护</h4>
        <!-- <el-divider></el-divider> -->
        <div slot="content">
            <el-table ref="table" @sort-change="sortChange" @filter-change="filterChange" :data="evaluateData" v-loading="examineeLoading"  show-summary :summary-method="getSummaries" max-height="780" size="mini">
                <el-table-column prop="examinee_name" column-key="examinee_name" :filters="filterData.examinee_name || []" sortable='custom' label="被考评人" header-align="center" align="center">
                    <template slot-scope="scope">
                        <div>{{scope.row.examinee_name}}{{scope.row.examinee_status === 0?'(离职)':''}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="examiner_name" column-key="examiner_name" :filters="filterData.examiner_name || []" sortable='custom' label="考评人" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" v-if="scope.row.amand" @click="setAmendExaminne(editRow,'examiner_name')" type="text">{{currentRow.examiner_name?currentRow.examiner_name:'请选择'}}{{currentRow.examiner_status === 0?'(离职)':''}}</el-button>
                        <span v-else>{{scope.row.examiner_name}}{{scope.row.examiner_status === 0?'(离职)':''}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="leader_name" column-key="leader_name" :filters="filterData.leader_name || []" sortable='custom' label="负责人" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" v-if="scope.row.amand" @click="setAmendExaminne(editRow,'leader_name')" type="text">{{currentRow.leader_name?currentRow.leader_name:'请选择'}}</el-button>
                        <span v-else>{{scope.row.leader_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否为专员" prop="is_commissioner" column-key="is_commissioner" :filters="options1" sortable='custom' header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-select size="mini" v-if="scope.row.amand" v-model="currentRow.is_commissioner">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <span v-else>{{scope.row.is_commissioner?'是':'不是'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="template_name" sortable='custom' column-key="template_name"  :filters="setAssessFormListData(assessFormList)" label="应填考核评分表" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" v-if="scope.row.amand" type="text" @click="settingTemplate(editRow)">{{currentRow.template_name?currentRow.template_name:'请选择'}}</el-button>
                        <span v-else>{{scope.row.template_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="editSetting(scope)" type="text">{{scope.row.amand?'取消':'编辑'}}</el-button>
                        <el-button size="mini" @click="saveSetting(scope)" type="text" style="margin-left:20px" :disabled="!scope.row.amand">保存</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <staff :visible="staffVisible" @confirmstaff="staffSele" @close="staffVisibles"></staff>
            <el-dialog :title="settingEvaluateDialog.title" :visible="settingEvaluateDialog.visible" width="400px" @close="evaluateDialogClose">
                <div>
                    <p v-for="assessForm in assessFormList" :key="assessForm.id">
                        <el-radio v-model="editRow.template_id" :label="assessForm.id">{{assessForm.name}}</el-radio>
                    </p>
                </div>
                <div style="margin-top: 10px;text-align: center;">
                    <el-button type="warning" size="mini" @click="evaluateDialogClose">取消</el-button>
                    <el-button type="primary" size="mini" @click="changeEvaluateInfo">确认</el-button>
                </div>
            </el-dialog>
        </div>
    </page-content>
</template>
<script>
import pageContent from '@/components/pageContent'
import  staff from '@/components/staff/Staff'
import {currentAssessDate,computeAssessDate} from '@/assets/js/date'
import {multiFilter,listSort} from '@/assets/js/filtrate'
export default {
    data(){
        return{
            evaluateData: [],
            scopeExaminne: '',           //修改考评人，负责人数据
            examineeLoading: false,      //被考评人列表loading
            staffVisible: false,         //员工对话框
            assessFormList: [],
            settingEvaluateDialog: {
                visible: false,
                title: ''
            },
            options1: [
                {value: 1,label: '是',text:'是'},
                {value: 0,label: '不是',text:'不是'},
            ],
            currentRow: {},
            editRow: {},
            editStatus: false,
            initData:[],                //初始数据
            tableFilter:[],             //筛选条件数据
            tableSort:{},               //排序条件数据
            evaluateData1:[],           //筛选数据
            filterData:[],              //筛选数据
        }
    },
    created(){
        this.getExaminee();
        this.getAssessFormData();
    },
    methods:{
        getSummaries(){                                     //页尾
            return [`共${this.evaluateData.length}条数据`]
        },
        sortChange({column,order,prop}){                    // 排序:ascending升序,descending降序
            this.tableSort={column,order,prop};
            this.editStatus = false;
            let isFilter=true;
            this.tableFilter.forEach((v,index)=>{           //查询是否存在筛选条件
                const $key=Object.keys(v)
                if(v[$key].length) isFilter=false;
            })
            const initData = JSON.parse(JSON.stringify(isFilter?this.initData:this.evaluateData1));
            const param=listSort([...initData],{order,prop});
            this.evaluateData=param;
        },
        filterChange(data){                                 //筛选
            this.editStatus = false;
            const initData = JSON.parse(JSON.stringify(this.initData));
            if(data){
                const val=Object.keys(data);
                if(this.tableFilter.length===0){                //保存全部筛选数据
                    this.tableFilter.push(data)
                }else{
                    let isKey=true;
                    this.tableFilter.forEach((v,index)=>{
                        const $key=Object.keys(v)
                        if(val[0] === $key[0]) isKey=index;
                    })
                    isKey===true ? (this.tableFilter.push(data)) : (this.tableFilter.splice(isKey,1,data))
                }
            }
            // this.$refs.table.clearSort()            //清除排序    
            this.evaluateData=this.evaluateData1=multiFilter(initData,this.tableFilter);
            if(this.tableSort.order!=null)  this.sortChange(this.tableSort); //排序存在
        },
        setAssessFormListData(data){                        //设置考核表筛选数据
            data.map(v=>{
                v.text=v.name;
                v.value=v.name
            })
            return data
        },
        getExaminee(){                                                  //获得被考评人数据
            this.examineeLoading=true;
            this.$http.get('maintain').then((v)=>{
                this.examineeLoading=false;
                if(v.status === 200){
                    this.evaluateData=v.data.data;
                    //用于初始数据
                    this.initData=JSON.parse(JSON.stringify(v.data.data));
                    this.setAllFilterData(JSON.parse(JSON.stringify(v.data.data)));
                    if(this.tableFilter.length) this.filterChange(false);
                }
            }).catch((v)=>{this.examineeLoading=false;})
        },
        setAllFilterData(data){     //获得筛选数据
            let filterData={
                leader_name:[],
                examinee_name:[],
                examiner_name:[],
            };
            for(let i in filterData){
                data.forEach(v=>{
                    if(!filterData[i].some(item=>item.text===v[i])){
                        filterData[i].push({
                            text:v[i],
                            value:v[i],
                        });
                    }
                })
            }
            this.filterData=filterData;
        },
        editSetting(scope) {        //编辑
            if(this.editStatus){
                if(!scope.row.amand){
                    this.$alert('当前正在编辑,保存或取消后,再进行此操作', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {}
                    });
                    return
                }
            }
            const $index=scope.$index;
            if(scope.row.amand){
                this.editStatus = false;
                this.evaluateData[$index].amand = false;
                this.evaluateData.splice($index,1,{...this.evaluateData[$index]})
            }else {
                this.editStatus = true;
                this.evaluateData[scope.$index].amand = true;
                let rowJson = JSON.stringify(scope.row);
                this.currentRow = JSON.parse(rowJson);
                this.editRow = JSON.parse(rowJson);
                let amand={amand:true}
                this.evaluateData.splice($index,1,{...this.evaluateData[$index],...amand})
            }
        },
        saveSetting(scope){             //保存
            const $index=scope.$index;
            let params={
                id: this.currentRow.id,
                examinee_id: this.currentRow.examinee_id,
                examiner_id: this.currentRow.examiner_id,
                leader_id: this.currentRow.leader_id,
                template_id: this.currentRow.template_id,
                is_commissioner: this.currentRow.is_commissioner,
            }
            this.$http.put('maintain',params).then((res)=>{
                if(res.status === 200){
                    this.editStatus = false;
                    this.getExaminee();
                    this.$message({message:res.data.message,type:'success'})
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        setAmendExaminne(row,v){                //设置考评人，负责人修改数据
            this.scopeExaminne={...row,amendName:v};
            this.staffVisibles()
        },
        staffVisibles(){                                                  //职员（对话框）
            this.staffVisible=!this.staffVisible;
        },
        staffSele(v,name){                                                   //职员选择
            const scope=this.scopeExaminne;
            if(scope.amendName === "examiner_name"){
                this.currentRow.examiner_id = v[0];
                this.currentRow.examiner_name = name[0];
            }else if(scope.amendName === "leader_name"){
                this.currentRow.leader_id = v[0];
                this.currentRow.leader_name = name[0];
            }
            this.staffVisibles()
        },
        amendExaminneData(params){            //修改考评人，负责人数据
            this.$http.put('maintain',params).then((v)=>{
                if(v.status === 200){
                    this.getExaminee();
                    this.$message({message:v.data.message,type:'success'})
                }
                this.staffVisibles()
            }).catch((v)=>{
                this.staffVisibles()
            })
        },
        getAssessFormData(){
            this.$http.get('maintain/template')
            .then((res)=>{
                if(res.status === 200){
                    let assessFormList = res.data.data;
                    let department_id = this.$store.state.login.userinfo['department_id'];
                    this.assessFormList = assessFormList.filter((item) => {
                        return department_id == item.department_id;
                    });
                }
            }).catch((err)=>{
                console.log(err)
            })
        },
        changeEvaluateInfo(){
            let assessFormName = ''
            for(let i = 0;i<this.assessFormList.length;i++){
                if(this.assessFormList[i].id == this.editRow.template_id){
                    assessFormName = this.assessFormList[i].name;
                    break;
                }
            }
            this.currentRow.template_id = this.editRow.template_id;
            this.currentRow.template_name = assessFormName;
            this.evaluateDialogClose();
        },
        settingTemplate(row){
            // this.currentRow = row;
            this.settingEvaluateDialog.title = '选择考核评分表';
            this.settingEvaluateDialog.visible = true;
        },
        evaluateDialogClose(){
            this.settingEvaluateDialog.visible = false;
        }
    },
    components:{
        staff,pageContent
    },
    
}
</script>
<style scoped>
    .el-button{
        font-size: 14px;
    }
    .deInfor-dropdown{
        color: #606266;
        background-color: #ffffff;
        border:1px solid #DCDFE6;
    }
</style>
